"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptySpacesLayer = void 0;
var GameVars_1 = require("../../../GameVars");
var Utils_1 = require("../../../utils/Utils");
var BoardManager_1 = require("../BoardManager");
var AudioManager_1 = require("../../../AudioManager");
var EmptySpacesLayer = /** @class */ (function (_super) {
    __extends(EmptySpacesLayer, _super);
    function EmptySpacesLayer(scene) {
        var _this = _super.call(this, scene) || this;
        var darkBackground = new Phaser.GameObjects.Graphics(_this.scene);
        darkBackground.fillStyle(0x321B38);
        darkBackground.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        darkBackground.alpha = .6;
        _this.add(darkBackground);
        var scaledItemsContainer = new Phaser.GameObjects.Container(_this.scene, GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2);
        scaledItemsContainer.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(scaledItemsContainer);
        var frame = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "message_box");
        scaledItemsContainer.add(frame);
        var titleBackground = new Phaser.GameObjects.Image(_this.scene, 0, -190, "texture_atlas_0", "title_cookie_base");
        scaledItemsContainer.add(titleBackground);
        var title = new Phaser.GameObjects.Image(_this.scene, 0, -190, "texture_atlas_1", "title_whoopsie");
        scaledItemsContainer.add(title);
        var labelStr = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["RAN_OUT"];
        var label = new Phaser.GameObjects.Text(_this.scene, 0, -15, labelStr, { fontFamily: "Baloo", fontSize: "45px", align: "center", color: "#95573F" });
        label.setOrigin(.5);
        scaledItemsContainer.add(label);
        var nextButton = new Utils_1.Button(_this.scene, 0, 140, "texture_atlas_1", "btn_ok_off", "btn_ok_on");
        nextButton.onDown(_this.onClickNext, _this);
        scaledItemsContainer.add(nextButton);
        nextButton.alpha = 0;
        _this.scene.tweens.add({
            targets: nextButton,
            y: 110,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            delay: 500
        });
        return _this;
    }
    EmptySpacesLayer.prototype.onClickNext = function () {
        BoardManager_1.BoardManager.hideEmptySpacesLayer();
        AudioManager_1.AudioManager.playSound("click_button");
    };
    return EmptySpacesLayer;
}(Phaser.GameObjects.Container));
exports.EmptySpacesLayer = EmptySpacesLayer;
